var ua = navigator.userAgent;
let preloadJs = function() {
  // Promise语法是ES6⽀持的，其他不⽀持的请⾃⾏转成ES5
  return new Promise((resolve, rejct) => {
    if (ua.toLowerCase().indexOf("xmsmk") !== -1) {
      if (window.UmsApi === undefined) {
        document.addEventListener(
          "OnUmsApiReady",
          function() {
            resolve(true);
          },
          false
        );
      } else {
        resolve(true);
      }
    } else {
      // ⾮市⺠卡接⼊
      reject("⾮市⺠卡接⼊");
    }
  });
};
let JsBridge = "";
let SCWJSBridge = ''
try {
  JsBridge = window.JSBridge.default;
  SCWJSBridge = new JsBridge();
  console.log('try');
} catch (e) {
  console.error(e);
}

export function ixmShare(data) {
  let obj = {
    title: data.title || "分享标题",
    desc: data.desc || "分享简介",
    link: data.link || location.origin + location.pathname + "#/",
    imgUrl: data.imgUrl || "",
  };
  console.log(obj);
  if (ua.match(/xmsmk/i) == "xmsmk" || ua.match(/xmsmk/i) == "XMSMK") {
    function share() {
      UmsApi.globalization.share(
        obj,
        function(data) {
          // 成功
          console.log("成功");
          // UmsApi.notification.toast("返回数据：" + JSON.stringify(data));
        },
        function(data) {
          // 失败
          console.log("失败");
          // UmsApi.notification.toast("返回数据：" + JSON.stringify(data));
        }
      );
    }
    preloadJs().then((res) => {
      // 调⽤市⺠卡相关⽅法
      share();
    });
  } else {
    // ixm.shareHandle(obj);
    SCWJSBridge.share(
      {
        title: data.title,
        content: data.desc,
        linkUrl: data.link,
      },
      (res) => {
        // 分享成功回调
        console.log("share success");
      },
      (err) => {
        console.error("share failure");
      }
    );

    // const JsBridge = window.JSBridge.default
  }
}

export function ixmWebView(data) {
  let url = "";
  let type = "";

  if (data.indexOf("APP:") != -1) {
    type = "APP";
    url = data.split("APP:")[1];
  }
  if (data.indexOf("LINK:") != -1) {
    type = "LINK";
    url = data.split("LINK:")[1];
  }
  console.log(type);
  if (
    type != "APP" &&
    (ua.match(/xmsmk/i) == "xmsmk" || ua.match(/xmsmk/i) == "XMSMK")
  ) {
    console.log("市民卡link");
    preloadJs().then((res) => {
      UmsApi.system.openWebPage.bySelf(url);
    });
  } else {
    location.href = url;
  }
}

//保存图片
export function ixmSaveImage(url) {
  var options = {
    base64Img: url,
    filePath: "⽂件夹名称",
  };
  if (ua.match(/xmsmk/i) == "xmsmk" || ua.match(/xmsmk/i) == "XMSMK") {
    function saveImage() {
      if (/Android/.test(ua)) {
        UmsApi.file.saveImage(options);
      } else {
        let data = {
          data: options,
        };
        window.webkit.messageHandlers.saveImage.postMessage(data);
      }
    }
    preloadJs().then((res) => {
      // 调⽤市⺠卡相关⽅法
      saveImage();
    });
  } else {
    // const JsBridge = window.JSBridge.default;
    // const SCWJSBridge = new JsBridge();
    // const data = {
    //   url: "http://ww4.sinaimg.cn/bmiddle/677febf5gw1erma1g5xd0j20k0esa7wj.jpg",
    // };
    SCWJSBridge.savePictureToAlbum(
      {
        url: "",
        fileData: options.base64Img,
      },
      (res) => {
        const code = res.code;
      },
      (error) => {
        const code = error.code;
      }
    );
  }
}
